import { Button, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import queryString from "query-string";
import React, { Component } from "react";
import { Cookies } from "react-cookie";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../../css/login.css";
import InputFormat from "../../partials/inputForm";
import { isJsonString, Token, version } from "../../utils/setting";
import ChangeLanguage from "../changeLanguage";
import CountryCode from "../countryCode";
import Loading from "../loading";
import Logo from "../logoWithText";
import Snackbar from "../snackbar";
import { styles } from "./styles.js";
const cookie = new Cookies();
class RegisterEmployee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        arrBranch: [],
      },
      anchorElLanguage: null,
      shortLinkID: false,
    };
  }
  handleChange = (e) => {
    let target = e.target;
    let { user } = this.state;
    user[target.name] = target.value;
    this.setState({ user });
  };

  async componentDidMount() {
    let { t } = this.props;
    if (
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.search
    ) {
      this.loading.startLoading();
      const parsed = queryString.parse(this.props.history.location.search);
      if (parsed && parsed.code) {
        let check = await this.props.decodeCodeInvite({ code: parsed.code });
        if (check && check.code === 1) {
          let data = check.data;
          if (data.arrBranch && isJsonString(data.arrBranch))
            data.arrBranch = JSON.parse(data.arrBranch);
          check.data = check.data || {};
          check.data.shortLinkID = parsed._id;
          console.log(check.data.shortLinkID);
          if (!check.data.shortLinkID)
            this.snackbar(t("register_employee_not_found_link"), "error");
          else
            this.setState(
              {
                user: { ...check.data },
                shortLinkID: check.data.shortLinkID ? true : false,
              },
              function () {}
            );
        } else if (check.error === 1199) {
          this.snackbar(
            t("register_employee_employee_register_successful"),
            "success"
          );
        } else {
          this.snackbar(t("register_employee_invalid_link"), "error");
        }
      }
      this.loading.stopLoading();
    }
    cookie.remove(Token);
  }
  snackbar = (message, type) => {
    this.mSnackbar.handleClick(message, type);
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    let { user } = this.state;
    let { t } = this.props;
    if (!user.firstName || !user.lastName) {
      this.mSnackbar.handleClick(
        t("profile_update_firstName_lastName_required"),
        "warning"
      );
    } else if (!user.password || !user.confirmPassword) {
      this.mSnackbar.handleClick(
        t("profile_please_fill_in_passwod_and_confirm_password"),
        "warning"
      );
    } else if (user.password && user.password.length < 6) {
      this.mSnackbar.handleClick(
        t(
          "Login_the_passord_field_length_must_be_greater_than_or_equal_to_6_characters_long"
        ),
        "warning"
      );
    } else if (user.password !== user.confirmPassword)
      this.mSnackbar.handleClick(
        t("profile_change_password_password_confirm_does_not_match"),
        "warning"
      );
    else {
      this.loading.startLoading();
      const { t } = this.props;
      if (user.arrBranch && typeof user.arrBranch !== "string") {
        user.arrBranch = user.arrBranch
          .filter((e) => e.branchCode)
          .map((e) => e.branchCode);
        user.arrBranch = JSON.stringify(user.arrBranch);
      }
      let check = await this.props.registerEmployee({
        user: user,
        snackbar: this.snackbar,
        t: t,
      });
      this.loading.stopLoading();
      if (check && check.code === 1) {
        this.mSnackbar.handleClick(
          t("employee_addemployee_register_success_pls_login")
        );
        this.props.history.push("/signin");
      } else {
        this.mSnackbar.handleClick(check.message, "error");
      }
    }
  };
  render() {
    const { t, classes } = this.props;
    const { user = {}, shortLinkID } = this.state;
    user.arrBranch = user.arrBranch || [];
    let branch = [];
    console.log(user.arrBranch);
    if (user.arrBranch && isJsonString(user.arrBranch)) {
      let arrBranch = JSON.parse(user.arrBranch) || [];
      branch = arrBranch.map((e) => e.branchName);
    } else if (Array.isArray(user.arrBranch)) {
      branch = user.arrBranch.map((e) => e.branchName);
    }
    return (
      <div className="login-wrapper">
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <ChangeLanguage />
        <div className="login-container">
          <div
            className={classes.logo}
            onClick={() => this.props.history.push("/")}
          >
            <Logo />
          </div>
          {shortLinkID && (
            <form onSubmit={this.handleSubmit} className={classes.container}>
              <Grid
                container
                spacing={3}
                justify="center"
                alignItems="flex-end"
              >
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    disabled={true}
                    label={t("service_ownerspa_spa")}
                    type="text"
                    name={"nameSpa"}
                    required
                    margin="none"
                    value={user.nameSpa || ""}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    disabled={true}
                    label={t("employee_addemployee_type_employee")}
                    type="text"
                    name={"typeEmployee"}
                    required
                    margin="none"
                    value={(user.typeEmployee || "").toUpperCase()}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    disabled={true}
                    label={t("employee_addemployee_arrBranch")}
                    type="text"
                    required
                    margin="none"
                    value={branch.join(", ")}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={5} sm={5} md={4}>
                  <CountryCode
                    code={user.countryCode}
                    disabled={true}
                    handleCountryCode={this.handleCountryCode}
                    margin="none"
                  />
                </Grid>
                <Grid item xs={7} sm={7} md={8}>
                  <InputFormat
                    required
                    disabled={true}
                    label={t("login_phone_number")}
                    placeholder={t("login_phone_number")}
                    name={"username"}
                    margin="none"
                    value={user.username || ""}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputFormat
                    required
                    label={t("register_first_name")}
                    placeholder={t("register_first_name")}
                    name={"firstName"}
                    margin="none"
                    value={user.firstName || ""}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputFormat
                    required
                    label={t("register_last_name")}
                    placeholder={t("register_last_name")}
                    name={"lastName"}
                    margin="none"
                    value={user.lastName || ""}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    label={t("login_password")}
                    type="password"
                    name={"password"}
                    required
                    margin="none"
                    value={user.password || ""}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    label={t("profile_confirm_password")}
                    type="password"
                    name={"confirmPassword"}
                    required
                    margin="none"
                    value={user.confirmPassword || ""}
                    onChange={this.handleChange}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={3}
                justify="center"
                alignItems="center"
                className={classes.btnBottom}
              >
                <Button
                  variant="contained"
                  size="large"
                  type="submit"
                  fullWidth
                  color="secondary"
                  onClick={this.handleSubmit}
                  className={classes.button}
                >
                  {t("sign_up")}
                </Button>
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ marginTop: 16 }}
              >
                <Link to="/signin">
                  <p className="text-gray">
                    {t("have_an_account")}
                    <span className="text-blue">&nbsp;{t("sign_in")}</span>
                  </p>
                </Link>
              </Grid>
            </form>
          )}
        </div>
        <div className="bottom-version">v {version}</div>
      </div>
    );
  }
}

RegisterEmployee.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  registerEmployee: dispatch.user.registerEmployee,
  decodeCodeInvite: dispatch.user.decodeCodeInvite,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(RegisterEmployee)
  )
);
